__webpack_require__.p = "https://beautifulslides-staging-static-assets.cdn.beautiful.ai/bundle/";